// Shared static constants (mock users/matches/messages removed in P0 remediation)
export const majorUSCities = [
  "New York, NY", "East Los Angeles, CA", "Chicago, IL", "Houston, TX", "Phoenix, AZ",
  "Philadelphia, PA", "San Antonio, TX", "San Diego, CA", "Dallas, TX", "San Jose, CA",
  "Austin, TX", "Jacksonville, FL", "Fort Worth, TX", "Columbus, OH", "Charlotte, NC",
  "San Francisco, CA", "Indianapolis, IN", "Seattle, WA", "Denver, CO", "Washington, DC",
  "Boston, MA", "El Paso, TX", "Nashville, TN", "Detroit, MI", "Oklahoma City, OK",
  "Portland, OR", "Las Vegas, NV", "Memphis, TN", "Louisville, KY", "Baltimore, MD",
  "Milwaukee, WI", "Albuquerque, NM", "Tucson, AZ", "Fresno, CA", "West Los Angeles, CA", "Orange County, CA",
  "Sacramento, CA", "Atlanta, GA", "Kansas City, MO", "Colorado Springs, CO", "Miami, FL",
  "Raleigh, NC", "Omaha, NE", "Long Beach, CA", "Virginia Beach, VA", "Oakland, CA",
  "Minneapolis, MN", "Tulsa, OK", "Arlington, TX", "Tampa, FL", "New Orleans, LA"
];

export const interestsList = [
  "Travel", "Music", "Food", "Photography", "Art", "Fitness", "Technology",
  "Reading", "Movies", "Dancing", "Cooking", "Hiking", "Coffee", "Wine",
  "Fashion", "Sports", "Gaming", "Yoga", "Meditation", "Theatre", "Comedy",
  "Nature", "Animals", "Volunteering", "Learning", "Adventure", "Beach",
  "Mountains", "City Life", "Nightlife", "Brunch", "Concerts", "Festivals"
];
